"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _ = require("../../");

var _v = _interopRequireDefault(require("uuid/v4"));

var _reactAutosuggest = _interopRequireDefault(require("react-autosuggest"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  } else {
    var newObj = {};

    if (obj != null) {
      for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
          var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};

          if (desc.get || desc.set) {
            Object.defineProperty(newObj, key, desc);
          } else {
            newObj[key] = obj[key];
          }
        }
      }
    }

    newObj.default = obj;
    return newObj;
  }
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AutoComplete =
/*#__PURE__*/
function (_Component) {
  _inherits(AutoComplete, _Component);

  function AutoComplete(props) {
    var _this;

    _classCallCheck(this, AutoComplete);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(AutoComplete).call(this, props));
    _this.state = {
      uuid: (0, _v.default)(),
      suggestions: _this.props.suggestions
    };
    return _this;
  }

  _createClass(AutoComplete, [{
    key: "render",
    value: function render() {
      var fetchRequest = this.props.onSuggestionsFetchRequested || this.defaultOnSuggestionsFetchRequested.bind(this);
      var clear = this.props.onSuggestionsClearRequested || this.defaultOnSuggestionsClearRequested.bind(this);
      var value = this.props.getSuggestionValue || this.defaultGetSuggestionValue.bind(this);
      var renderSuggestion = this.props.renderSuggestion || this.defaultRenderSuggestion.bind(this);
      return _react.default.createElement("div", {
        className: this.wrapperClass()
      }, _react.default.createElement("label", {
        className: "control-label",
        htmlFor: this.state.uuid
      }, this.props.label, this.renderRequired()), _react.default.createElement(_reactAutosuggest.default, {
        inputProps: this.inputProps(),
        suggestions: this.state.suggestions,
        onSuggestionsFetchRequested: fetchRequest,
        onSuggestionsClearRequested: clear,
        getSuggestionValue: value,
        renderSuggestion: renderSuggestion,
        theme: this.theme(),
        onSuggestionSelected: this.props.onSuggestionSelected
      }));
    }
  }, {
    key: "inputProps",
    value: function inputProps() {
      return {
        id: this.state.uuid,
        value: this.props.value,
        onChange: this.props.onChange,
        className: 'form-control',
        placeholder: this.props.placeholder
      };
    }
  }, {
    key: "wrapperClass",
    value: function wrapperClass() {
      var str = 'form-group';
      var context = this.props.context;

      if (context && _.Input.contexts[context]) {
        str += " has-".concat(_.Input.contexts[context]);
      }

      return str;
    }
  }, {
    key: "defaultOnSuggestionsFetchRequested",
    value: function defaultOnSuggestionsFetchRequested(_ref) {
      var value = _ref.value,
          reason = _ref.reason;
      var matcher = new RegExp(value, 'i');
      this.setState({
        suggestions: this.props.suggestions.filter(function (s) {
          return matcher.exec(s);
        })
      });
    }
  }, {
    key: "defaultOnSuggestionsClearRequested",
    value: function defaultOnSuggestionsClearRequested() {}
  }, {
    key: "defaultGetSuggestionValue",
    value: function defaultGetSuggestionValue(suggestion) {
      return suggestion;
    }
  }, {
    key: "defaultRenderSuggestion",
    value: function defaultRenderSuggestion(suggestion) {
      return _react.default.createElement("span", null, suggestion);
    }
  }, {
    key: "theme",
    value: function theme() {
      return {
        container: 'dropdown',
        containerOpen: 'open',
        input: 'react-autosuggest__input',
        inputOpen: 'react-autosuggest__input--open',
        inputFocused: 'react-autosuggest__input--focused',
        suggestionsContainer: 'suggestions-container',
        suggestionsContainerOpen: 'suggestions-container-open',
        suggestionsList: 'dropdown-menu',
        suggestion: 'react-autosuggest__suggestion',
        suggestionFirst: 'react-autosuggest__suggestion--first',
        suggestionHighlighted: 'suggestion-highlighted',
        sectionContainer: 'react-autosuggest__section-container',
        sectionContainerFirst: 'react-autosuggest__section-container--first',
        sectionTitle: 'react-autosuggest__section-title'
      };
    }
  }, {
    key: "renderRequired",
    value: function renderRequired() {
      if (this.props.required) {
        return _react.default.createElement("em", {
          className: "required-mark",
          "aria-hidden": "true",
          title: "Required"
        }, "*");
      }
    }
  }]);

  return AutoComplete;
}(_react.Component);

var _default = AutoComplete;
exports.default = _default;